import { Descriptions, Flex, Table, Typography } from 'antd';
import type { TableProps } from 'antd';

import { Schemas } from '@api-client/generated/types';
import { countries } from '@constants';

import { getCountryDataByCode } from '../helpers';

type Person = Schemas.PersonResponseDto;
type CounterpartyInfo = Schemas.CounterpartyInfoDto;

type CompanyStructureProps = {
  incorporation: Schemas.Incorporation;
  companyItself: Person;
};

const { Title } = Typography;

export const CompanyInfo = (props: CompanyStructureProps) => {
  const columns: TableProps<CounterpartyInfo>['columns'] = [
    {
      title: 'Name or category',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Estimated turnover',
      dataIndex: 'turnover',
      key: 'turnover',
      render: (turnover) => turnover ?? '-',
    },
    {
      title: 'Country',
      dataIndex: 'countryCode',
      key: 'countryCode',
      render: (countryCode) => getCountryDataByCode(countryCode) ?? '-',
    },
    {
      title: 'Type of partner',
      dataIndex: 'type',
      key: 'type',
    },
  ];

  return (
    <Flex vertical>
      <Title level={5}>General</Title>
      <Descriptions
        items={[
          {
            key: 'country',
            label: 'Country',
            children:
              countries.find(
                (e) => e.code === props.incorporation.address?.countryCode
              )?.name || '-',
          },
        ]}
      />

      <Title level={5}>Counterparties Info</Title>
      <Table<CounterpartyInfo>
        rowKey={(row) => `${row.name}-${row.turnover}`}
        columns={columns}
        dataSource={props.companyItself.kycData?.counterpartiesInfo ?? []}
        pagination={false}
      />
    </Flex>
  );
};
